module.exports = __webpack_public_path__ + "img/card_digitizedfile_hover.8faee900.svg";